import SparkMD5 from 'spark-md5'
import drfProvider from 'ra-data-drf'
import httpClient from './httpClient'
import { HttpError } from 'react-admin'

const provider = drfProvider(`${process.env.API_URL}/api/v1`, httpClient)

const CHUNK_SIZE = 4096
const UPLOAD_URL = `${process.env.API_URL}/api/v1/upload`
const noop = () => {}
const getChunk = (file, start, end) => {
    let slice = file.mozSlice || file.webkitSlice || file.slice || noop;
    return slice.bind(file)(start, end);
}


/**
 * For Empresas update only, convert uploaded document in base 64 and attach it to
 * the `documents` sent property, with `src` and `title` attributes.
 */
const addDocumentUpload = dataProvider => async (type, resource, params) => {
    // For documentos update only
    if (type === 'UPDATE' && resource === 'documentos') {
        if (params.data.file) {
            if (params.data.file.rawFile instanceof File) {
                // Get file size
                const file = params.data.file.rawFile
                const totalSize = file.size

                let checksum;
                const reader = new FileReader()
                reader.onloadend = function () {
                    checksum = SparkMD5.ArrayBuffer.hash(reader.result);
                };
                reader.readAsArrayBuffer(file)

                // If file is small enough, send whole file
                if (totalSize <= CHUNK_SIZE) {
                    // Send POST request with file, filename, md5, type & decreto
                    let formData = new FormData()
                    formData.append("file", file)
                    formData.append("md5", checksum)
                    //formData.append("type", params.data.type)
                    //formData.append("decreto", params.data.decreto)
                    formData.append("filename", params.data.file.title)

                    try {
                        await httpClient(`${UPLOAD_URL}/`, {
                            method: "POST",
                            body: formData,
                            headers: new Headers({ Accept: 'application/json' })
                        })
                    } catch (e) {
                        console.log(e)
                        return Promise.reject(e)
                    }
                } else {
                    // First Chunk
                    let start = 0
                    let end = start + CHUNK_SIZE

                    let formData = new FormData()
                    formData.append("file", getChunk(file, start, end))
                    formData.append("type", params.data.type)
                    formData.append("decreto", params.data.decreto)
                    formData.append("filename", params.data.filename)

                    let headers = new Headers({ Accept: 'application/json' })
                    headers.set('Content-Range', `bytes ${start}-${end-1}/${totalSize}`)
                    try {
                        let chunkResponse = await httpClient(`${UPLOAD_URL}/`, {
                            method: 'PUT',
                            body: formData,
                            headers
                        })
                        const documentUrl = chunkResponse.json.url

                        // Remaining chunks
                        start = chunkResponse.json.offset
                        while (end < totalSize){
                            end = start + CHUNK_SIZE
                            if (end > totalSize) {
                                end = totalSize
                            }

                            formData = new FormData()
                            formData.append("file", getChunk(file, start, end))

                            headers = new Headers({ Accept: 'application/json' })
                            headers.set('Content-Range', `bytes ${start}-${end-1}/${totalSize}`)
                            chunkResponse = await httpClient(documentUrl, {
                                method: 'PUT',
                                body: formData,
                                headers
                            })
                            start = chunkResponse.json.offset
                        }

                        formData = new FormData()
                        formData.append("md5", checksum)
                        return httpClient(documentUrl, {
                            method: 'POST',
                            body: formData,
                            headers: new Headers({ Accept: 'application/json' })
                        })
                    } catch (e) {
                        console.log(e)
                        return Promise.reject("Upload Failed")
                    }
                }
            }
        }
    }
    // for other request types and resources, fall back to the default request handler
    return dataProvider(type, resource, params).then(res => (res)).catch(e => {
        if(e.status === 400)
            e.message = 'Error'

        throw new HttpError(e.message, e.status, e.body)
    })
};

export default addDocumentUpload(provider);
